module.exports = __webpack_public_path__ + "static/media/web_design.4a747e82.svg";